// @flow @jsx h

/* eslint-disable compat/compat */

import { ScrollSlideshow } from '@nrk/dh-feature-components'
import { Component, h } from 'preact'
import Background from './Background'
import Section from './Section'
import style from './index.css'

import type { Bio } from './types'
import type { Viewport } from '../../types'

type Props = {
  index: number,
  value: {
    bios: Bio[],
    id: string
  },
  mediaBaseUrl: string,
  onAnalyticsEvent: Function,
  viewport: Viewport
}

class CharacterPresentation extends Component<Props> {
  render () {
    const { mediaBaseUrl, onAnalyticsEvent, viewport } = this.props
    const { bios, id } = this.props.value

    return (
      <ScrollSlideshow
        className={style.characterSlideshow}
        id={id}
        backgrounds={bios.map((bio, idx) => (
          <Background
            {...bio}
            key={String(idx)}
            mediaBaseUrl={mediaBaseUrl}
            viewport={viewport}
          />
        ))}
        sections={bios.map((bio, idx) => (
          <Section {...bio} key={String(idx)} viewport={viewport} />
        ))}
        onAnalyticsEvent={onAnalyticsEvent}
        viewport={viewport}
      />
    )
  }
}

export default CharacterPresentation



// WEBPACK FOOTER //
// ./src/v1/components/Article/Content/CharacterPresentation/index.js